// src/api/timeReconcileApi.js
// Time Reconciliation (Autotask → "Missing Time"). Every call goes through
// apiClient so the token is acquired per request — never window.__mspToken.

import apiClient from "./apiClient";

// POST /api/time-reconcile/scan { start, end } — Perth local YYYY-MM-DD, inclusive, ≤ 31 days. Read-only.
export async function scanRange(start, end) {
  const response = await apiClient.post("/api/time-reconcile/scan", { start, end }, { timeout: 120000 });
  return response.data;
}

// POST /api/time-reconcile/check — recompute ONE row's coverage against a chosen company (server-side).
export async function checkItem(item, companyId) {
  const { key, startUtc, endUtc, dateLocal, subject } = item;
  const response = await apiClient.post("/api/time-reconcile/check", { item: { key, startUtc, endUtc, dateLocal, subject }, companyId }, { timeout: 60000 });
  return response.data;   // { company: { id, name, source: "manual" }, coverage }
}

// GET /api/time-reconcile/ticket-by-number/:ticketNumber → { id, ticketNumber, title, companyID, status, statusName } (404 → throws)
export async function findTicketByNumber(ticketNumber) {
  const response = await apiClient.get(`/api/time-reconcile/ticket-by-number/${encodeURIComponent(String(ticketNumber || "").trim())}`);
  return response.data;
}

// POST /api/time-reconcile/dismiss { key, reason, subject, dateLocal } — never attendees
export async function dismissItem(item, reason) {
  const response = await apiClient.post("/api/time-reconcile/dismiss", { key: item.key, reason, subject: item.subject, dateLocal: item.dateLocal });
  return response.data;   // { ok, key, dismissed: { reason, at } }
}

// DELETE /api/time-reconcile/dismiss/:key — restore
export async function restoreItem(key) {
  const response = await apiClient.delete(`/api/time-reconcile/dismiss/${encodeURIComponent(key)}`);
  return response.data;
}

// GET /api/timelog/my-roles → { resourceId, roles: [{ roleID, name, kind }] } default first
export async function getMyRoles() {
  const response = await apiClient.get("/api/timelog/my-roles");
  return response.data.roles || [];
}
